<section class="p-2 p-md-4">
  <app-form-associacao-auditoria (formulario)="updateListAssociacao($event)"></app-form-associacao-auditoria>
</section>

<section class="py-4">
  <app-list-associacao-auditoria></app-list-associacao-auditoria>
</section>